import React from 'react';
// @ts-ignore
import styles from './ManagerCertificates.module.scss';
import Text from '../../../../../../Components/Base/Text/Text';
import ManagerCertificatesList from '../ManagerCertificatesList/ManagerCertificatesList';
import ManagerServicesList from '../ManagerServicesList/ManagerServicesList';
import { useManagerContext } from '../../../../Services/ManagerContext';
import { isAllowed } from '../../../../../../Services/acl.service';

interface SectionProps {
	title: string;
	children: React.ReactElement | React.ReactElement[];
}

const Section: React.FC<SectionProps> = ({ title, children }) => {
	return (
		<>
			<Text tx={title} className={styles.title} firstUpper />
			{children}
		</>
	);
};

const ManagerCertificates: React.FC = () => {
	const { rootWorkplaceId, workplaceId } = useManagerContext();

	return (
		<div className={styles.wrapper}>
			{rootWorkplaceId && isAllowed('manager_rootworkplace_certificates') && (
				<Section title='base.certificatesOfHealthCompany'>
					<ManagerCertificatesList workplaceId={rootWorkplaceId} />
					<hr />
				</Section>
			)}
			{isAllowed('manager_workplace_certificates') && (
				<Section title='base.workplaceCertificates'>
					<ManagerCertificatesList workplaceId={workplaceId} />
					<hr />
				</Section>
			)}
			<Section title='base.service'>
				<ManagerServicesList />
			</Section>
		</div>
	);
};

export default ManagerCertificates;
